import { KYMW1308Model } from '../kymw1308.model';
import { KYMW1308CalcApprovedPriceModel } from '../vo/kymw1308-calc-approved-price.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * バンドルミックスマッチ画面　成立価格を算出するサービス
 *
 * @export CalcApprovedPriceService
 * @class CalcApprovedPriceService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class CalcApprovedPriceService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1308Model}
   * @memberof CalcApprovedPriceService
   */
  private model: KYMW1308Model;

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {KYMW1308CalcApprovedPriceModel}
   * @memberof CalcApprovedPriceService
   */
  private vo: KYMW1308CalcApprovedPriceModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CalcApprovedPriceService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        CalcApprovedPrice: {
          condition: {
            DiscountPercent: this.vo.discountPercent
          },
          combination: this.vo.discountGoodsList.map(obj => {
            return {
              condition: {
                PCode: obj.pCode,
                ThisTimeSupplyPriceIB: obj.thisTimeSupplyPriceIB,
                ThisTimeSupplyPriceTO: obj.thisTimeSupplyPriceTO,
                ThisTimeSupplyPriceGU: obj.thisTimeSupplyPriceGU,
                ThisTimeSupplyPriceTI: obj.thisTimeSupplyPriceTI,
                ThisTimeSupplyPriceSA: obj.thisTimeSupplyPriceSA,
                ThisTimeSupplyPriceTK: obj.thisTimeSupplyPriceTK,
                ThisTimeSupplyPriceNA: obj.thisTimeSupplyPriceNA,
                ThisTimeSupplyPriceNI: obj.thisTimeSupplyPriceNI,
                ThisTimeSupplyPriceKU: obj.thisTimeSupplyPriceKU
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof CalcApprovedPriceService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1308Model>model;
    this.vo = vo;
    this.send('calcApprovedPrice', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CalcApprovedPrice
   */
  success(data: any): void {
    this.model.updateApprovedPrice(data);
    this.model.KYMW1308Component.btn_Reflection.nativeElement.focus();
  }
}
